const decorator = str => 'settings/' + str;


export const SETTING_LOADED = decorator('SETTING_LOADED');
export const SLIDES_LOADED = decorator('SLIDES_LOADED');
export const CONTENT_LOADED = decorator('CONTENT_LOADED');
export const PAYMENTS_LOADED = decorator('PAYMENTS_LOADED');
export const ANSWERS_LOADED = decorator('ANSWERS_LOADED');
